import VariantPicker from '@theme/variant-picker';

/**
 * A variant-picker that switches between separate products (the current product's
 * "family", via the productFamilyList metafield) instead of between variants of a
 * single product. Uses its own tag name so it never collides with the main
 * `<variant-picker>` element when the browser looks up which element to morph.
 */
class FamilySwatchesPicker extends VariantPicker {}

if (!customElements.get('family-swatches-picker')) {
  customElements.define('family-swatches-picker', FamilySwatchesPicker);
}
